import { colors } from '../style/colors';
import styled from 'styled-components';
import { HorizontalRedLines, InterventionsLogoSingle } from '../lib/shared';
import { fonts } from '../style/typography';
import { min } from '../lib/responsive';

const SchedulePageContainer = styled.div`
  background-color: ${props => (props.isInPerson ? props.WHITE : colors.GRAY)};
  margin-top: -3rem;
`;

const ScheduleTableContainer = styled.div`
  background-color: ${props => (props.isInPerson ? props.WHITE : colors.GRAY)};
  padding-top: 10rem;
`;

const InterventionsLogoSchedule = styled(InterventionsLogoSingle)`
  margin-top: -1.2rem;
`;

const ScheduleDivider = styled.div`
  width: 100%;
  height: 0.1rem;
  background-color: ${props =>
    props.isInPerson ? colors.BLACK : colors.WHITE};
  z-index: 10;
`;

const ScheduleInterventionsLogo = styled.img`
  z-index: 10;
  width: 9.3rem;
  cursor: pointer;
  padding-top: 2rem;
  position: absolute;
`;

const ToggleButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1em;

  @media ${min.tablet} {
    flex-direction: row;
    gap: 2.5em;
  }

  @media ${min.desktop} {
    flex-direction: row;
    gap: 4em;
  }
`;
const InPersonToggleButton = styled.button`
  color: ${colors.WHITE};
  cursor: pointer;
  background-color: ${isInPerson =>
    isInPerson.isInPerson ? colors.RED : 'transparent'};
  border: 0.05em solid;
  border-color: ${isInPerson =>
    isInPerson.isInPerson ? 'transparent' : colors.WHITE};
  text-transform: uppercase;
  width: 12.5em;
  height: 2.5em;
  font-family: ${fonts.degular};
  font-size: 1.3em;

  @media ${min.tabletSm} {
    font-size: 2em;
  }

  @media ${min.tablet} {
    font-size: 1.65em;
  }

  @media ${min.tabletLg} {
    font-size: 2.25em;
  }

  @media ${min.desktop} {
    font-size: 3em;
  }
`;

const OnlineToggleButton = styled.button`
  color: ${isInPerson => (isInPerson.isInPerson ? colors.RED : colors.WHITE)};
  cursor: pointer;
  background-color: ${isInPerson =>
    isInPerson.isInPerson ? 'transparent' : colors.RED};
  border: 0.05em solid;
  border-color: ${isInPerson =>
    isInPerson.isInPerson ? colors.RED : 'transparent'};
  text-transform: uppercase;
  width: 12.5em;
  height: 2.5em;
  font-family: ${fonts.degular};
  font-size: 1.3em;

  @media ${min.tabletSm} {
    font-size: 2em;
  }

  @media ${min.tablet} {
    font-size: 1.65em;
  }

  @media ${min.tabletLg} {
    font-size: 2.25em;
  }

  @media ${min.desktop} {
    font-size: 3em;
  }
`;

export {
  SchedulePageContainer,
  ScheduleTableContainer,
  InterventionsLogoSchedule,
  ScheduleDivider,
  ScheduleInterventionsLogo,
  ToggleButtonContainer,
  InPersonToggleButton,
  OnlineToggleButton,
};
